import React from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import {
  hideReactivateStaffModal,
  assignEmployeeToSlot,
  setAssignedEmployee,
} from 'actions/employees/staff';
import moment from 'moment';
import { getFormValues } from 'redux-form';
import styles from './ReactivateStaffModal.css';

class ReactivateStaffModal extends React.Component {
  render() {
    const { showReactivateStaffModal, availableSlots } = this.props;
    return (
      <Modal
        onHide={this._onHide}
        show={showReactivateStaffModal}
        dialogClassName={`${styles.dialog} modal-dialog`}
      >
        <Modal.Header>
          <button
            onClick={this._onHide}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <Modal.Title className={styles['title-modal']}>
            Please Select one of your available slot to reactivate this employee
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table className="table table-hover table-responsive">
            <thead>
              <tr>
                <th>Slot Status</th>
                <th>Expiration Date</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              {availableSlots.length > 0 &&
                availableSlots.map(slot => (
                  <tr key={slot.id}>
                    <td>{slot.status}</td>
                    <td>{moment(slot.expireDate).format('DD MMM YYYY')}</td>
                    <td className={styles.right}>
                      <button
                        type="button"
                        onClick={() => this._onClickAssign(slot)}
                        className={`btn btn-primary ${styles['btn-assign']}`}
                      >
                        Assign to this slot
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          <hr />
        </Modal.Body>
      </Modal>
    );
  }

  _onHide = () => {
    const { dispatch } = this.props;
    dispatch(hideReactivateStaffModal());
    dispatch(setAssignedEmployee(null));
  };

  _onClickAssign = slot => {
    const { assignedEmployee, user, dispatch, staffFormValues } = this.props;
    dispatch(
      assignEmployeeToSlot({
        slot,
        employee: assignedEmployee,
        user,
        staffFormValues,
      })
    );
  };
}

function mapStateToProps(state) {
  const {
    showReactivateStaffModal,
    availableSlots,
    assignedEmployee,
  } = state.employee.staff;
  const { user } = state.moka;
  return {
    showReactivateStaffModal,
    availableSlots,
    assignedEmployee,
    user,
    staffFormValues: getFormValues('staff')(state),
  };
}

export default connect(mapStateToProps)(ReactivateStaffModal);
